import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { AccountStatusModel } from 'common/models/account-status';
import { ToastService } from 'common/services/toast.service';
import { AccountStatusState } from 'common/store/account-status/account-status.state';
import { UserValidationService } from 'private/app/services/user-validation/user-validation.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'hvac-delete-my-account',
    templateUrl: './delete-my-account.component.html',
    styleUrls: ['./delete-my-account.component.scss']
})
export class DeleteMyAccountComponent implements OnInit {
    @Select(AccountStatusState.getProfileInfo) userInfo$: Observable<AccountStatusModel>;
    ngOnDestroy$ = new Subject();
    public isConfirmCheckboxSelected: boolean = false;
    public deleteAccountConfirmationModelVisible: boolean = false;
    public systemsList: string[] = [];
    public apiRequestActive = false;
    public isLoading = false;

    public accountDeletionForm: UntypedFormGroup = new UntypedFormGroup({
        email: new UntypedFormControl({
            value: '',
            disabled: true
        }),
        userId: new UntypedFormControl({
            value: '',
            disabled: true
        }),
        confirmDeletion: new UntypedFormControl(false)
    });

    constructor(
        private userValidationService: UserValidationService,
        private toastService: ToastService,
        private translate: TranslateService
    ) { }

    ngOnInit(): void {
        this.userInfo$.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((profileInfo) => {
            this.setFormValues(profileInfo);
        });
        this.loadSystemsList();
    }


    changeConfirmationControl(_value: Event) {
        this.isConfirmCheckboxSelected = !this.isConfirmCheckboxSelected;
    }

    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    deletAccountRequest() {
        this.apiRequestActive = true;
        this.isLoading = true;
        this.deleteAccountConfirmationModelVisible = false;
        this.isConfirmCheckboxSelected = false;
        this.userValidationService.deleteAccountRequest().subscribe((response) => {
            if (response) {
                this.isLoading = false;
                this.apiRequestActive = false;
                this.toastService.add({
                    content: response.details,
                    id: 'delete-account-toast',
                    theme: 'success',
                    closeable: true,
                    autoClose: true
                });
            }
        }, (error) => {
            this.isLoading = false;
            this.apiRequestActive = false;
            this.toastService.add({
                content: error.message,
                id: 'delete-account-toast',
                theme: 'error',
                closeable: true,
                autoClose: true
            });
        });
    }

    private setFormValues(user: AccountStatusModel) {
        if (user) {
            this.accountDeletionForm.controls.email.setValue(user.email || '');
            this.accountDeletionForm.controls.userId.setValue(user.userId || '');
        }
    }

    private loadSystemsList() {
        this.translate.get('ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.SYSTEMS_LIST').subscribe((systems: string[]) => {
            this.systemsList = systems;
        });
    }
}
